import './polyfill';

import * as Sentry from '@sentry/browser';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { addLocaleData } from 'react-intl';
import * as de from 'react-intl/locale-data/de';
import * as en from 'react-intl/locale-data/en';

import { reportError, setPresentation, showHelpContent } from "./actions";
import App from './containers/App';
import reducers, { HelpPanelContentType } from './reducers';
import { getProcessStepTranslations, setupTranslationStore } from "./services/translation-store";

import './index.css';
import { loadAllPresentationOverviews, loadPresentation } from "./services/presentation-store";


// import registerServiceWorker from './registerServiceWorker';

Sentry.init({
    dsn: "https://2265edb47d564601ab7ce04d413a104e@sentry.io/1403383"
});

addLocaleData([...en, ...de]);

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(thunk))
);


ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root') as HTMLElement
);

// TODO: Remove once presentation-chooser is implement
(async () => {
    const presentations = await loadAllPresentationOverviews()
        .catch(error => {
            store.dispatch(reportError(error));
            return [];
        });
    if (presentations.length > 0) {
        const presentation = await loadPresentation(presentations[0].id)
            .catch(error => { store.dispatch(reportError(error)) });
        if (presentation) {
            store.dispatch(setPresentation(presentation));
            await setupTranslationStore();
            store.dispatch(
                showHelpContent(
                    HelpPanelContentType.General,
                    getProcessStepTranslations(presentation.processStep).help_content,
                )
            );
        }
        // store.dispatch(
        //     showGenericDialog('introduction_dialog_title', 'introduction_dialog_content')
        // );
    }
})();


// WEBPACK FOOTER //
// ./src/index.tsx